module.exports = require("/opt/build/repo/src/styles/typography.js")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 376
// module chunks = 231608221292675